(function (Drupal, $, once) {
  Drupal.behaviors.expandableToggle = {
    attach: function (context) {
      const $button = $('.sidebar__expandable-toggle', context);

      if (window.openFilters == undefined) {
        window.openFilters = [];
      }

      $(once('expandableToggle', $button)).on('click', function() {
        const $parent = $(this).parent();
        const parentDataSelector = $parent.data('drupal-selector');
        let $region = $('.sidebar__expandable-inside', $parent);
        let isExpanded = $(this).attr('aria-expanded');

        if (isExpanded === 'false') {
          $(this).attr('aria-expanded', 'true');
          window.openFilters.push(parentDataSelector)
          $region.show();
        } else {
          $(this).attr('aria-expanded', 'false');
          window.openFilters = window.openFilters.filter(function(value) {
            return value !== parentDataSelector;
          });
          $region.hide();
        }
      });

      $(document).ajaxComplete(function (e, xhr, settings) {
        window.openFilters.forEach(function(drupalSelector) {
          let $parent = $('[data-drupal-selector="' + drupalSelector + '"]');
          let $toggle = $('.sidebar__expandable-toggle', $parent);
          let $region = $('.sidebar__expandable-inside', $parent);
          $toggle.attr('aria-expanded', true);
          $region.show();
        });
      });
    }
  };
}(Drupal, jQuery, once));